window.Products.Bag.ToteBag = function() {
};
window.Products.Bag.ToteBag.inherits(window.Products.Bag.Bag);
window.Products.Bag.ToteBag.id = 18;
window.Products.Bag.ToteBag.slug = 'tote-bag';
window.Products.Bag.ToteBag.has_3d = true;
window.Products.Bag.ToteBag.dpi = 150;
window.Products.Bag.ToteBag.rotate_fit = true;
window.Products.Bag.ToteBag.fit_template_all = true;
window.Products.Bag.ToteBag.preview_data = {
	texture_width: 2048,
	texture_height: 2048,
	scenes: {
		main: {
			deltax: [25, 395],
			deltay: 93,
			originalWidth: 371,
			originalHeight: 341,
			scaleWidth: 1024,
			scaleHeight: 944,
			preview_x: [0, 1024],
			preview_y: [556, 556],
			ratio: 41.98,
			tools: ['mirror_side', 'fit_center', 'fit_side', 'rotation_assist', 'toggle_bleed'],
			warnings: [
				{x:26 , y:94},
				{x:765, y:94},
				{x:765, y:433},
				{x:26 , y:433},
                
                // middle point warning
				{x:365 , y:132},
				{x:426 , y:132},
				{x:365 , y:393}, 
				{x:426, y:393},				
                {x:394, y: 136},
				{x:394, y: 389},                
                {x:410, y: 136},
				{x:410, y: 389},
                {x:378, y: 136},
				{x:378, y: 389}
			]
		}
	}
};

/* Objects 
	0 - Out
	1 - In Dark
	2 - In Light
	3 - In Lighter
	4 - Rivets
	5 - Brass
	6 - Zipper
	7 - Strap in
	8 - Strap out
*/

window.Products.Bag.ToteBag.prototype.set3dProperties = function(modelViewer) {
	var me = this;

	modelViewer.object.position.y = -0.65;
	modelViewer.ambient_light.intensity = 0.7;

	// Lighten the canvas
	modelViewer.object.children[0].material.color.setHex(16776176);

	if($('#productInfo-productOption-style').find(':selected').attr('value') == "604"){
		me.setMetal(modelViewer);
	}

	if(modelViewer.inlab) {
		//me.setStrap('428', modelViewer);
	} else {
		$('#productInfo-productOption-strap-color').trigger('change');
	}

	me.updateThreeTexture(modelViewer);
};

window.Products.Bag.ToteBag.prototype.updateThreeTexture = function(modelViewer) {
	modelViewer.object.children[0].material.map = modelViewer.texture;
};

window.Products.Bag.ToteBag.prototype.setMetal = function(modelViewer){
	var me = this, metals = [4,5,6];
	
	var enable = function(){
		for(var i = 0; i < metals.length; i++){
			modelViewer.object.children[metals[i]].material.envMap = me.envMap;
			modelViewer.object.children[metals[i]].material.envMap.mapping = THREE.EquirectangularReflectionMapping;
			modelViewer.object.children[metals[i]].material.needsUpdate = true;
			modelViewer.object.children[metals[i]].material.envMap.needsUpdate = true;
		}
	};

	if(!me.envReady){
		me.loadEnvMap(enable);
	} else {
		enable();
	}
};

window.Products.Bag.ToteBag.prototype.setStrap = function(type, modelViewer){
	var me = this, o = modelViewer.object;

	var style = $('#productInfo-productOption-style').find(':selected').attr('value');

	if(style == "604" && !o.children[7]) return;

	switch(type){
		case '606': // Cotton, Black
			o.children[1].material.color.r = 0.20;
			o.children[1].material.color.g = 0.22;
			o.children[1].material.color.b = 0.22;
			o.children[1].material.shininess = 2;
			o.children[1].material.specular.r = 0.004;
			o.children[1].material.specular.g = 0.004;
			o.children[1].material.specular.b = 0.004;
			o.children[2].material.color.r = 0.20;
			o.children[2].material.color.g = 0.22;
			o.children[2].material.color.b = 0.22;
			break;
		case '607': // Cotton, Natural
			o.children[1].material.color.r = 1.00;
			o.children[1].material.color.g = 0.97;
			o.children[1].material.color.b = 0.89;
			o.children[1].material.shininess = 2;
			o.children[1].material.specular.r = 0.004;
			o.children[1].material.specular.g = 0.004;
			o.children[1].material.specular.b = 0.004;
			o.children[2].material.color.r = 1.00;
			o.children[2].material.color.g = 0.97;
			o.children[2].material.color.b = 0.89;
			break;
		case '608': // Vegan Leather, Black
			o.children[7].material.color.r = 0.20;
			o.children[7].material.color.g = 0.22;
			o.children[7].material.color.b = 0.22;
			o.children[8].material.color.r = 0.32;
			o.children[8].material.color.g = 0.32;
			o.children[8].material.color.b = 0.32;
			break;
		case '609': // Vegan Leather, Navy
			o.children[7].material.color.r = 0.10;
			o.children[7].material.color.g = 0.18;
			o.children[7].material.color.b = 0.24;
			o.children[8].material.color.r = 0.14;
			o.children[8].material.color.g = 0.24;
			o.children[8].material.color.b = 0.32;
			break;
		case '610': // Vegan Leather, Brown
			o.children[7].material.color.r = 0.35;
			o.children[7].material.color.g = 0.24;
			o.children[7].material.color.b = 0.17;
			o.children[8].material.color.r = 0.75;
			o.children[8].material.color.g = 0.41;
			o.children[8].material.color.b = 0.25;
			break;
		case '611': // Polyester, Black
			o.children[1].material.color.r = 0.20;
			o.children[1].material.color.g = 0.20;
			o.children[1].material.color.b = 0.20;
			o.children[1].material.shininess = 15;
			o.children[1].material.specular.r = 0.1;
			o.children[1].material.specular.g = 0.1;
			o.children[1].material.specular.b = 0.1;
			o.children[2].material.color.r = 0.20;
			o.children[2].material.color.g = 0.20;
			o.children[2].material.color.b = 0.20;
			break;
		case '612': // Polyester, Grey
			o.children[1].material.color.r = 0.64;
			o.children[1].material.color.g = 0.64;
			o.children[1].material.color.b = 0.64;
			o.children[1].material.shininess = 15;
			o.children[1].material.specular.r = 0.1;
			o.children[1].material.specular.g = 0.1;
			o.children[1].material.specular.b = 0.1;
			o.children[2].material.color.r = 0.64;
			o.children[2].material.color.g = 0.64;
			o.children[2].material.color.b = 0.64;
			break;
	}
};

window.Products.Bag.ToteBag.prototype.setThreeControls = function(controls) {
	controls.minDistance = 2.9;
	controls.maxDistance = 3.8;
};